export default __webpack_public_path__ + "static/media/4_elec_group.dfbac758.png";